<p>
  Защитата на вашия профил е от съществено значение за сигурността на личните ви данни, активността в платформата и
  самите сделки. Добрата защита предпазва от злоупотреби, фалшиви действия и неоторизиран достъп.
</p>
<h6 class="mt-3">1. Използвайте сигурна парола</h6>
<ul>
  <li>Паролата трябва да съдържа поне 8 символа.</li>
  <li>Използвайте комбинация от <strong>главни и малки букви</strong>, <strong>цифри</strong> и <strong>специални
    символи</strong> (напр. <code>!#$%</code>).
  </li>
  <li>Избягвайте лесни за отгатване пароли като <em>123456</em>, <em>qwerty</em>, <em>вашето име</em> и др.</li>
</ul>
<h6 class="mt-3">2. Не споделяйте данните си за вход</h6>
<p>
  Вашето потребителско име и парола са лични. Не ги предоставяйте на никого – включително на лица, които се представят
  за администратори. Нашият екип <strong>никога няма да поиска вашата парола</strong>.
</p>
<h6 class="mt-3">3. Бъдете внимателни с имейлите и линковете</h6>
<p>
  Ако получите съмнителен имейл с линк към страница за вход или форма за лични данни, не го отваряйте. Уверете се, че
  адресът започва с <strong>https://collectoria.bg</strong> и съдържа защитена връзка.
</p>
<h6 class="mt-3">4. Наблюдавайте активността по профила си</h6>
<p>
  Ако забележите съмнителна активност (напр. неочаквана промяна в обяви или получаване на имейл за смяна на парола,
  която не сте инициирали), незабавно сменете паролата си и се свържете с нас чрез
  <a class="text-decoration-none"
     [routerLink]="[appRoutes.root, appRoutes.contactUs]">
    формата за контакт.
  </a>
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Променяйте паролата си периодично и не използвайте една и съща парола за различни сайтове.
  Това е най-лесният начин да повишите общата си киберсигурност.
</div>
